import * as tslib_1 from "tslib";
import BrandSubscriptionListView from './BrandSubscriptionListView';
import loadBrandsSubscriptions from '../actions/loadBrandsSubscriptions';
import getStore from '../store/store';
import { observer } from 'mobx-react';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { OptionDescription } from 'owa-options-controls';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
var styles = require('./BrandsSubscriptionsFull.scss');
var BrandsSubscriptionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(BrandsSubscriptionsFull, _super);
    function BrandsSubscriptionsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrandsSubscriptionsFull.prototype.componentDidMount = function () {
        loadBrandsSubscriptions();
    };
    BrandsSubscriptionsFull.prototype.render = function () {
        var store = getStore();
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, this.getNumberOfSubscriptionsMessage(store.subscriptions.length)),
            React.createElement("div", null,
                React.createElement("span", { className: styles.subscriptions }, strings.optionTitle_subscriptionActions),
                React.createElement("span", { className: styles.sortBy },
                    React.createElement("span", null, strings.options_subscriptions_sortBy),
                    React.createElement(Dropdown, { selectedKey: 'Name', className: styles.dropdown, options: [
                            {
                                key: 'Name',
                                text: strings.options_subscriptions_sortByName,
                            },
                            {
                                key: 'Frequency',
                                text: strings.options_subscriptions_sortByFrequency,
                            },
                        ] }))),
            React.createElement(BrandSubscriptionListView, { brandsSubscriptions: store.subscriptions, isUnsubscribed: false }),
            React.createElement("div", { className: styles.unsubscribed }, strings.options_subscriptions_unsubscribed),
            React.createElement(BrandSubscriptionListView, { brandsSubscriptions: store.unsubscribedSubscriptions, isUnsubscribed: true })));
    };
    BrandsSubscriptionsFull.prototype.getNumberOfSubscriptionsMessage = function (length) {
        return format(strings.options_subscriptions_numberOfSubscriptions, length);
    };
    BrandsSubscriptionsFull = tslib_1.__decorate([
        observer
    ], BrandsSubscriptionsFull);
    return BrandsSubscriptionsFull;
}(React.Component));
export default BrandsSubscriptionsFull;
//# sourceMappingURL=BrandsSubscriptionsFull.js.map